import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEn = () => {
    return (
        <HighlightedText
            text="YOU HAVE WON 400 FREESPINS"
            highlights={[{ word: '400' }]}
            breakAfterWords={['WON']}
            className={styles.text_content}
        />
    )
}
